<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../../api.js';
    import UserStore from '../../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 
    import License from '../../components/License.svelte'; 
    import Token from '../../components/Token.svelte'; 
    

    let isLoading = false;


    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
    })


    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment"> 
            <Token />
            
            <div class="container content-container shopify m-0 p-0">
                <h1 class="text-3xl font-bold mb-4">{$_('docs.shopify.title')}</h1>
            
                <h2 id="shopify-installation" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.shopify.installation.title')}</h2>
                <p class="text-base mb-4">{$_('docs.shopify.installation.intro_1')}</p>
                <p class="text-base mb-4">{$_('docs.shopify.installation.intro_2')}</p>
                <p class="text-base mb-4">
                {$_('docs.shopify.installation.intro_3.before_link')}
                <br>
                <a href="https://apps.shopify.com/israel-post-domestic" target="_blank" class="text-blue-600 hover:underline">
                    {$_('docs.shopify.installation.intro_3.link_text')}
                </a>
                </p>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.installation.app_store_access')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.shopify.installation.app_store_step_1')}</li>
                <li>{$_('docs.shopify.installation.app_store_step_2')}</li>
                <li>{$_('docs.shopify.installation.app_store_step_3')}</li>
                </ol>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.installation.find_app')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.shopify.installation.find_app_step_1')} {docs_shipping_company_name}</li>
                <li>{$_('docs.shopify.installation.find_app_step_2')}</li>
                </ol>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.installation.install')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.shopify.installation.install_step_1')}</li>
                <li>{$_('docs.shopify.installation.install_step_2')}</li>
                <li>{$_('docs.shopify.installation.install_step_3')}</li>
                </ol>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.installation.permissions')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.shopify.installation.permissions_step_1')}</li>
                <li>{$_('docs.shopify.installation.permissions_step_2')}</li>
                </ol>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.installation.completion')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.shopify.installation.completion_step_1')}</li>
                <li>{$_('docs.shopify.installation.completion_step_2')}</li>
                </ol>
            
                <p class="text-base mb-4">{$_('docs.shopify.installation.success')}</p>
                <p class="text-base mb-4">{$_('docs.shopify.installation.support_info')}</p>
            
                <h2 id="shopify-getting-started" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.shopify.getting_started.title')}</h2>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.getting_started.configuration')}</h3>
                <p class="text-base mb-4">{$_('docs.shopify.getting_started.config_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.shopify.getting_started.config_step_1')}</li>
                <li>{$_('docs.shopify.getting_started.config_step_2')}</li>
                </ol>
            
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.shopify.getting_started.account_settings')}</h4>
                <p class="text-base mb-4">{$_('docs.shopify.getting_started.account_settings_intro')}</p>
                <ul class="list-disc list-inside mb-4">
                <li>{$_('docs.shopify.getting_started.account_settings_step_1')}</li>
                </ul>
            
                <h2 id="shopify-usage" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.shopify.usage.title')}</h2>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.usage.widgets')}</h3>
                <p class="text-base mb-4">{$_('docs.shopify.usage.widgets_intro')}</p>
            
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.shopify.usage.orders_list')}</h4>
                <ol class="list-decimal list-inside mb-4">
                <li><strong>{$_('docs.shopify.usage.orders_list_step_1_title')}</strong> {$_('docs.shopify.usage.orders_list_step_1')}</li>
                <li><strong>{$_('docs.shopify.usage.orders_list_step_2_title')}</strong> {$_('docs.shopify.usage.orders_list_step_2')}</li>
                <li><strong>{$_('docs.shopify.usage.orders_list_step_3_title')}</strong> {$_('docs.shopify.usage.orders_list_step_3')}</li>
                </ol>
            
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.shopify.usage.order_page')}</h4>
                <ol class="list-decimal list-inside mb-4">
                <li><strong>{$_('docs.shopify.usage.order_page_step_1_title')}</strong> {$_('docs.shopify.usage.order_page_step_1')}</li>
                <li><strong>{$_('docs.shopify.usage.order_page_step_2_title')}</strong> {$_('docs.shopify.usage.order_page_step_2')}</li>
                <li><strong>{$_('docs.shopify.usage.order_page_step_3_title')}</strong> {$_('docs.shopify.usage.order_page_step_3')}</li>
                </ol>
            
                <h2 id="shopify-troubleshooting" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.shopify.troubleshooting.title')}</h2>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.troubleshooting.common_issues')}</h3>
                <p class="text-base mb-4">
                <strong>{$_('docs.shopify.troubleshooting.error_title')}</strong> - 
                {$_('docs.shopify.troubleshooting.error_text')}
                </p>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.troubleshooting.faq')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>
                    <div><strong>{$_('docs.shopify.troubleshooting.faq_1_q')}</strong></div>
                    <div>{$_('docs.shopify.troubleshooting.faq_1_a')}</div>
                </li>
                <li>
                    <div><strong>{$_('docs.shopify.troubleshooting.faq_2_q')}</strong></div>
                    <div>{$_('docs.shopify.troubleshooting.faq_2_a')}</div>
                </li>
                </ol>
            
                <h2 id="shopify-support" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.shopify.support.title')}</h2>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.support.getting_help')}</h3>
                <p class="text-base mb-4">{$_('docs.shopify.support.getting_help_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                <li><strong>{$_('docs.shopify.support.help_step_1_title')}</strong> {$_('docs.shopify.support.help_step_1')}</li>
                <li><strong>{$_('docs.shopify.support.help_step_2_title')}</strong> {$_('docs.shopify.support.help_step_2')}</li>
                </ol>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.support.reporting')}</h3>
                <p class="text-base mb-4">{$_('docs.shopify.support.reporting_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                <li><strong>{$_('docs.shopify.support.report_step_1_title')}</strong> {$_('docs.shopify.support.report_step_1')}</li>
                <li><strong>{$_('docs.shopify.support.report_step_2_title')}</strong> {$_('docs.shopify.support.report_step_2')}</li>
                </ol>
            
                <h2 id="shopify-changelog" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.shopify.changelog.title')}</h2>
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.shopify.changelog.version')}</h3>
                <ul class="list-disc list-inside mb-4">
                <li><strong>{$_('docs.shopify.changelog.added_title')}</strong> {$_('docs.shopify.changelog.added')}</li>
                <li><strong>{$_('docs.shopify.changelog.updated_title')}</strong> {$_('docs.shopify.changelog.updated')}</li>
                <li><strong>{$_('docs.shopify.changelog.fixed_title')}</strong> {$_('docs.shopify.changelog.fixed')}</li>
                <li><strong>{$_('docs.shopify.changelog.removed_title')}</strong> {$_('docs.shopify.changelog.removed')}</li>
                </ul>
            
                <h2 id="shopify-license" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.shopify.license.title')}</h2>
                <License />
            </div>

        </div>
    </div>
</div>